import { Space, Spin } from 'antd';

import { Select } from '@style/global-style.app';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input } from '@atom/form/input/input';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { getTestId } from '@util/data/get-test-id';

import { initialNewApplicationForm } from './new-application.form-initial';
import { newApplicationFormValidation } from './new-application.form-validation';

interface NewApplicationFormInterface extends BaseFormInterface {
  accounts: { value: string; label: string }[];
}

export const NewApplicationForm = ({ form, accounts, error, isLoading = false }: NewApplicationFormInterface) => (
  <Form autoComplete='off' form={form} initialValues={initialNewApplicationForm} layout='vertical' name='application'>
    <Space direction='vertical' size={24}>
      <div id='step-1'>
        {!isLoading && accounts.length > 1 && (
          <Form.Item label='Team' name='account' rules={[{ required: true }]}>
            <Select options={accounts} />
          </Form.Item>
        )}
        <Form.Item label='Application name' name='name' rules={[newApplicationFormValidation]}>
          <Input placeholder='Please input application name' {...getTestId(TestIdsEnum.ApplicationNameInput)} />
        </Form.Item>
      </div>
      <Form.Item>
        <div id='step-2'>
          <Button htmlType='submit' type={ButtonTypeEnum.Primary} block {...getTestId(TestIdsEnum.CommonButtonSubmit)}>
            {isLoading && <Spin />}
            {!isLoading && 'CONTINUE'}
          </Button>
        </div>
      </Form.Item>
    </Space>
    <FormError error={error} errorField='name' />
  </Form>
);
